// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1cIXg","colCheckbox":"styles_colCheckbox__1w1vA"};